import { Table, TableBody, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import { useContext, useEffect, useState } from 'react';
import 'react-querybuilder/dist/query-builder.css';
import { Link } from 'react-router-dom';
import type { Edulead } from 'edulead';
import Banner from 'src/custom-components/Banner';
import LoadingBars from '../custom-components/LoadingBars';
import { GlobalContext, GlobalContextProps } from '../global-context';
import { eduleadV4 } from '../services/edulead-v4-client';
import { allPages, toastV4Error } from '../services/edulead-v4';
import General from '../utils/GeneralUtils';
import './Trackings.scss';

export function Trackings(props: any) {

  const globalContext = useContext(GlobalContext);
  General.setTitle(document, 'Tracking', globalContext);

  const [isLoadingTeamDomains, setIsLoadingTeamDomains] = useState(false);
  const [teamSites, setTeamSites] = useState<Edulead.EduleadV4Site[] | null>(null);

  async function loadTeamDomains() {
    try {
      setIsLoadingTeamDomains(true)
      setTeamSites(await allPages(eduleadV4.sites.list({ page_size: 500 })))
    } catch (err) {
      toastV4Error(err, 'Something went wrong loading supported domains')
    } finally {
      setIsLoadingTeamDomains(false)
    }
  }

  useEffect(() => {
    if (globalContext.authInfo?.teamId) {
      loadTeamDomains()
    } else {
      setIsLoadingTeamDomains(true)
    }
  }, [globalContext.authInfo?.teamId]);

  return <GlobalContext.Consumer>
    {
      (globalContextProps: GlobalContextProps) => <>
        <div className={`content content-800`}>
          <h1 className="trackings__title">Tracking</h1>
          <Banner color="blue" style={{ marginBottom: 20 }}>
            Track which districts are visiting your website with Edulead.
          </Banner>
          <h4 className="trackings__section-title">Websites to Track</h4>
          {
            isLoadingTeamDomains
              ? <LoadingBars numberOfRows={3} />
              : teamSites &&
                <Table size='small' className="trackings__table">
                  <TableHead>
                    <TableCell as='th'>Website</TableCell>
                  </TableHead>
                  <TableBody>
                    {
                      teamSites.map((site) => {
                        return <TableRow key={site.id}>
                          <TableCell>
                            <Link to={`/tracking/${site.id}`}>{site.domain}</Link>
                          </TableCell>
                        </TableRow>
                      })
                    }
                  </TableBody>
                </Table>
          }
        </div>
      </>
    }
  </GlobalContext.Consumer>
}
